<template>

    <div class="searchbar" :class="classes">
        <input :placeholder="placeholder" v-model="val" @keydown.enter="action" />
        <a v-if="mag" href="#" class="mag" @click.prevent="action">
            <i class="fas fa-search"></i>
        </a>
    </div>

</template>

<style scoped lang="scss">

    .searchbar {
        min-width: 250px;
        overflow: hidden;
        position: relative;
        .mag {
            @include font-medium(14px);
            color: $color-text;
            display: grid;
            height: 100%;
            right: 0;
            opacity: 0.3;
            place-items: center;
            position: absolute;
            text-decoration: none;
            top: 0;
            transition: opacity .3s;
            &:hover {
                opacity: 0.5;
            }
        }
        input {
            @include font-medium(13px);
            appearance: none;
            background: #fff;
            border: 1px solid $color-rule;
            border-radius: 3px;
            box-sizing: border-box;
            color: $color-text;
            display: block;
            flex-grow: 1;
            height: 40px;
            outline: none;
            padding: 0 40px 0 15px;
            transition: border-color .3s;
            width: 100%;
            &:hover, &:focus {
                border-color: $color-text;
                color: $color-text;
            }
        }
    }

    .searchbar {
        &.searchbar-sm {
            input {
                font-size: 12px;
                height: 34px;
                padding: 0 34px 0 10px;
            }
            .mag {
                height: 34px;
                width: 34px;
            }
        }
        &.searchbar-md {
            input {
                font-size: 13px;
                height: 40px;
                padding: 0 40px 0 15px;
            }
            .mag {
                height: 40px;
                width: 40px;
            }
        }
    }

</style>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        mag: {
            type: Boolean,
            default: true,
        },
        size: {
            type: String,
            default: 'md',
        },
        placeholder: {
            type: String,
            default: 'Search...',
        },
        action: {
            type: Function,
            default: function() {},
        },
    },

    data() {
        return {
            val: this.model,
        }
    },

    computed: {

        classes() {
            return {
                'searchbar-sm': this.size === 'sm',
                'searchbar-md': this.size === 'md',
            }
        },

    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

}

</script>
